import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import LazyLoad from 'react-lazyload';
import animateScrollTo from 'animated-scroll-to';
import Select from 'react-select';
import { ShareFat } from '@phosphor-icons/react';
// import Banner from '../../../common/Banner/Banner';
import Sharing from '../../../common/sharing/Sharing';
import ErrorPage from '../../../common/errorPage/ErrorPage';
import HeaderTags from '../../../common/headerTags/HeaderTags';
import Spinner from '../../../common/Spinner/Spinner';
import MusicCardContainer from '../../musics/containers/MusicCardContainer';

const headerTagsJson = require('./headertags.json');

// basic banner config
// const multiBannerConfig = {
//     title: 'PUBLICIDADE',
//     class: 'col-12',
//     adUnit: 'a1nova-top100-multi_multi_sizes',
//     sizes: [[970, 250], [970, 90], [728, 90], [336, 280], [320, 50], [300, 250], [300, 100], [250, 250], [234, 60]],
//     sizeMapping: [
//         { viewport: [1250, 0], sizes: [[970, 250], [970, 90], [728, 90]] },
//         { viewport: [991, 0], sizes: [[728, 90], [336, 280], [300, 250], [300, 100]] },
//         { viewport: [365, 0], sizes: [[336, 280], [320, 50], [300, 250], [300, 100]] },
//         { viewport: [0, 0], sizes: [[250, 250], [234, 60]] },
//     ],
//     shouldRefresh: true,
// };

// @TODO change to functional components

class Top100 extends Component {
    componentDidMount() {
        // get data to Musics (if needed)
        this.props.getListMusicsIfNeeded(this.props.slug);

        // go to top
        animateScrollTo(0, { speed: 700 });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.slug !== this.props.slug) {
            // get data to Musics
            this.props.getListMusicsIfNeeded(this.props.slug);
        }
    }

    _handlingYears = (selectedOption) => {
        // change url
        this.props.history.push(`/as-100-mais/${selectedOption.value}`);

        // go to top
        animateScrollTo(0, { speed: 700 });
    }

    render() {
        if (this.props.notFound === true) {
            return <ErrorPage
                errorNumber={404}
                backLink="/as-100-mais"
                title="NÃO FORAM ENCONTRADAS MÚSICAS PARA ESTE ANO :("
                message="Mas  temos  várias outras."
                buttonText="Clique aqui e veja outras 100 mais."
            />;
        }

        // Mapping select options (years)
        const selectOptions = [];

        this.props.listYears.length > 0 &&
            this.props.listYears.map((data) => {
                const yearList = data.ano;

                return yearList && selectOptions.push({ value: yearList, label: yearList });
            });

        const year = this.props.slug || (selectOptions[0] ? selectOptions[0].value : '2020'); // The default year should only be used while fetching the top100 data clientside
        const keywords = headerTagsJson[year] ? headerTagsJson[year].keywords : false;

        if (!keywords) {
            // eslint-disable-next-line no-console
            console.error('no keywords found for year: ', year);
        }

        const headerTags = {
            title: `As 100+ - Ranking das músicas mais pedidas de ${year}`, // | Antena 1 is automatically added by the Headers Tag
            meta:
            {
                description: `Confira o ranking das 100 músicas mais pedidas da programação pelos ouvintes no ano de ${year}. Veja os grandes sucessos que marcaram o ano da Antena 1!`,
                keywords,
                'og:title': `As 100+ - Ranking das músicas mais pedidas de ${year}`,
                'og:description': `Confira o ranking das 100 músicas mais pedidas da programação pelos ouvintes no ano de ${year}. Veja os grandes sucessos que marcaram o ano da Antena 1!`,
                'og:image': 'https://a1media.antena1.com.br/image/share/as-100-mais.png',
            },
        };

        // Custom react-select style

        const customStyles = {
            container: () => ({
                width: '100%',
            }),
            control: (base) => ({
                ...base,
                borderColor: '#d1d5db',
                boxShadow: 'none',
                '&:hover': {
                    borderColor: '#d1d5db',
                },
            }),
            indicatorSeparator: () => ({
                color: 'transparent',
            }),
            menu: (base) => ({
                ...base,
                borderRadius: '8px',
                backgroundColor: '#fff',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            }),
            option: (base, { isFocused, isSelected }) => ({
                ...base,
                backgroundColor: isSelected ? '#F2F4F7' : isFocused ? '#F2F4F7' : '#fff',
                color: '#000',
                padding: '10px',
            }),
        };

        return (

            <section className="Top100">
                <HeaderTags title={headerTags.title} meta={headerTags.meta} />
                <header>
                    <h1>As 100 + da Antena 1</h1>
                    <p className="tw-text-black tw-text-center">Veja as músicas mais pedidas pelos ouvintes</p>
                </header>
                <div className="block-selectYear">
                    <Select
                        id="selectYear"
                        instanceId="selectYear"
                        styles={customStyles}
                        options={selectOptions}
                        value={selectOptions.find((option) => option.value === year)}
                        onChange={this._handlingYears}
                        isSearchable={false}
                        hideSelectedOptions
                        // The following line remove the radius border from every element on react-select
                        theme={(theme) => ({
                            ...theme,
                            borderRadius: 0,
                        })}
                    />
                </div>
                {
                    this.props.listMusics.length > 0
                        ? <Top100Musics year={year} listMusics={this.props.listMusics} />
                        : <Spinner customClass="spinnerTop100" />
                }
            </section>
        );
    }
}

class Top100Musics extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showSharing: false,
        };
    }

    _activeSharingDialog = (position) => {
        // check if value already was clicked
        this.state.showSharing === position
            ? this.setState({
                showSharing: false,
            })
            : this.setState({
                showSharing: position,
            });
    }

    _mapMusics() {
        const showSharing = this.state.showSharing;
        // create the playlist with all musicItems that contain a musicTrack
        const playlistData = [];

        this.props.listMusics.forEach((music) => {
            if (music.musicTrack) {
                // Note: Not sure if all of those props are actually necessary for the playlist
                playlistData.push({
                    musicName: music.musicName,
                    musicId: music.musicId,
                    musicSlug: music.musicSlug,
                    musicTrack: music.musicTrack,
                    artistName: music.artistName,
                    artistSlug: music.artistSlug,
                    albumCover: music.albumCoverSlug,
                    albumName: music.albumName,
                    itunesCover: (music.itunesCover && music.itunesCover !== 'notFound') ? music.itunesCover : undefined,
                });
            }
        });

        return this.props.listMusics.map((music, index) => {
            const position = index + 1;
            // logic to insert banner peer 5
            // const showBanner = position === 1 || position % 5 === 0;
            const shareLocation = `/as-100-mais/${this.props.year}`;

            // Title for sharings
            const shareTitle = `${music.artistName} - ${music.musicName} / ${position}ª posição  nas 100+ da ANTENA 1 de ${this.props.year}!`;

            const musicItemData = {
                musicName: music.musicName,
                musicId: music.musicId,
                musicSlug: music.musicSlug,
                musicTrack: music.musicTrack,
                artistName: music.artistName,
                artistSlug: music.artistSlug,
                albumCover: music.albumCoverSlug,
                albumName: music.albumName,
                itunesCover: (music.itunesCover && music.itunesCover !== 'notFound') ? music.itunesCover : undefined,
            };

            return (
                [
                    <LazyLoad key={position} className="top100item" offset={500} once>
                        <React.Fragment>
                            <MusicCardContainer
                                music={musicItemData}
                                key={position}
                                // playlist
                                playlistType={`top100-${this.props.year}`}
                                playlistData={playlistData}
                                musicIndex={position}
                            />

                            {showSharing === position &&
                                <div className="balloonDialogueShare">
                                    <Sharing
                                        path={shareLocation}
                                        iconSize={18}
                                        widthBlockIcon={30}
                                        shareButtonsTo={['facebook', 'twitter', 'whatsapp']}
                                        facebook={{ quote: shareTitle, hashtag: '#Antena1' }}
                                        twitter={{ title: shareTitle, hashtags: ['As100+', 'Antena1'] }}
                                        whatsapp={{ title: shareTitle }}
                                    />
                                </div>}
                            <button
                                type="button"
                                className="tw-rounded-full tw-w-[30px] tw-h-[30px] tw-flex tw-justify-center tw-items-center tw-absolute tw-right-[4px] tw-bottom-[4px]"
                                title={`Compartilhar ${music.musicName}`}
                                onClick={() => this._activeSharingDialog(position)}
                            >
                                <ShareFat size={20} weight="regular" />
                            </button>
                        </React.Fragment>
                    </LazyLoad>,
                    // showBanner &&
                    // <LazyLoad key={`Publicidade ${position}`} offset={500} once>
                    //     <Banner key={`Publicidade ${position}`} config={multiBannerConfig} />
                    // </LazyLoad>,
                ]
            );
        });
    }

    render() {
        return (
            <div className="musicsContainer tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-y-10 tw-gap-x-12 lg:tw-px-8">
                {this._mapMusics()}
            </div>
        );
    }
}

Top100Musics.propTypes = exact({
    listMusics: PropTypes.arrayOf(PropTypes.object),
    year: PropTypes.string,
});

Top100.propTypes = exact({
    slug: PropTypes.string,
    history: PropTypes.object,
    listYears: PropTypes.arrayOf(PropTypes.object),
    listMusics: PropTypes.arrayOf(PropTypes.object),
    getListMusicsIfNeeded: PropTypes.func,
    notFound: PropTypes.bool,
});

export default Top100;
